// src\components\AwardsSection.tsx
import { Button, Card, Carousel, Typography, Image } from 'antd';
import { LinkOutlined, TrophyOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import FitiImage from '../assets/awards/fiti.jpeg';
import Innoserve from '../assets/awards/2024innoserve.jpg';
import Csmu from '../assets/awards/2023csmu.jpeg';
import Cht5g from '../assets/awards/2023cht5g.jpeg';
import MeetTaipei from '../assets/awards/2026meet_taipei.jpg';
import Ces from '../assets/awards/2026ces.jpg';

const { Title, Paragraph } = Typography;

interface AwardItem {
  image: string;
  title: string;
  category: string;
  url?: string;
}

const AwardsSection = () => {
  const { t } = useTranslation();

  const awards: AwardItem[] = [
    {
      image: MeetTaipei,
      title: t('awards.items.meet_taipei.title'),
      category: t('awards.items.meet_taipei.subtitle'),
      url: t('awards.items.meet_taipei.url'),
    },
    {
      image: Ces,
      title: t('awards.items.ces.title'),
      category: t('awards.items.ces.subtitle'),
      url: t('awards.items.ces.url'),
    },
    {
      image: FitiImage,
      title: t('awards.items.fiti.title'),
      category: t('awards.items.fiti.category'),
      url: t('awards.items.fiti.url'),
    },
    {
      image: Innoserve,
      title: t('awards.items.innoserve.title'),
      category: t('awards.items.innoserve.category'),
    },
    {
      image: Csmu,
      title: t('awards.items.csmu.title'),
      category: t('awards.items.csmu.category'),
    },
    {
      image: Cht5g,
      title: t('awards.items.cht5g.title'),
      category: t('awards.items.cht5g.category'),
    },
  ];

  return (
    <section className="awards-section">
      <div className="section-container">
        <div className="section-header">
          <TrophyOutlined className="section-icon" />
          <Title level={2}>{t('awards.title')}</Title>
          <Paragraph className="section-subtitle">
            {t('awards.subtitle')}
          </Paragraph>
        </div>

        <Carousel
          arrows
          autoplay
          autoplaySpeed={4500}
          dots
          infinite
          slidesToShow={4}
          slidesToScroll={1}
          responsive={[
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
              },
            },
          ]}
          className="awards-carousel"
        >
          {awards.map((award, index) => (
            <div className="award-slide" key={index}>
              <Card
                className="award-card"
                bordered={false}
                hoverable
                cover={
                  <div className="award-image-wrapper">
                    <Image
                      src={award.image}
                      alt={award.title}
                      preview={false}
                      fallback="/placeholder-award.jpg"
                    />
                  </div>
                }
              >
                <Card.Meta
                  title={award.title}
                  description={
                    <div className="award-meta">
                      <span>{award.category}</span>
                      {award.url && (
                        <Button
                          type="link"
                          size="small"
                          href={award.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          icon={<LinkOutlined />}
                          className="award-link"
                        >
                          {t('awards.linkLabel')}
                        </Button>
                      )}
                    </div>
                  }
                />
              </Card>
            </div>
          ))}
        </Carousel>
      </div>
    </section>
  );
};

export default AwardsSection;
